import { useContext } from "react"
import { Button, DialogActions, Stack, Typography } from "@mui/material"
import { OkCancelContext } from "lib/@hooks/useDialog"
import { If } from "lib/@components/switch"

export function LegislationLibraryChooseFolderActions({ browsingId, currentPath, confirmDisabled, disabledReason }) {
    const { ok, cancel } = useContext(OkCancelContext)

    return (
        <DialogActions>
            <Stack direction="row" alignItems="center" spacing={1.5} justifyContent="flex-end" sx={{ width: 1 }}>
                <If value={!!disabledReason}>
                    <Typography variant="caption" color="text.secondary" data-cy="legislation-choose-folder-reason">
                        {disabledReason}
                    </Typography>
                </If>
                <Button onClick={cancel} color="inherit" data-cy="legislation-choose-folder-cancel">
                    Cancel
                </Button>
                <Button
                    onClick={() => ok({ id: browsingId, path: currentPath })}
                    variant="contained"
                    disabled={confirmDisabled}
                    data-cy="legislation-choose-folder-confirm"
                >
                    Move Here
                </Button>
            </Stack>
        </DialogActions>
    )
}
